const initialState = {
  studentBinderTableData: {
    isError: false,
    isLoading: false,
    items: [],
  },
};

export default initialState;
